import { TabularCopySink } from './tabular.copysink';
import { Metamodel } from 'app/model/base/model';
import { IAttribute, IModel } from 'app/model/base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { MysqlTableDataset } from 'app/model/dataset/mysql-table.dataset';

@Metamodel.model({
    name: adfModelTypeMap.mysql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(MysqlTableDataset)] }
})
export class MySqlSink extends TabularCopySink {
    public static readonly MODEL: IModel;
     public static readonly WRITE_BEHAVIOR: IAttribute;
    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
        this.writeBatchSize = 10000;
        this.writeBatchTimeout = '00:00:30';
    }

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior: 'insert' | 'upsert' = 'insert';
}
